import React from 'react'
import DialogWrapper from './DialogWrapper'
import Button from './Button'

export default function DataWarning( { setUser, closeDataWarning } ) {

  return (
    <DialogWrapper
        id='data-warning'
    >
        <p className='font-bold py-10'>
            Without an account, game data may be lost, and player statistics may have inaccuracies.
        </p>
        <Button
            color='green'
            clickFunction={() => {
                let storage = JSON.parse(localStorage.getItem('turdle-data-key'))
                storage.username = 'guest'
                localStorage.setItem('turdle-data-key', JSON.stringify(storage))
                closeDataWarning();
                setUser('guest');
            }}
        >
            Continue?
        </Button>
        <Button
            color='gray'
            clickFunction={closeDataWarning}    
        >
            Cancel
        </Button>
    </DialogWrapper>
  )
}
